
import React, { Component } from 'react'
import { parse } from 'qs'
import { connect } from 'react-redux'
import { createSession } from 'actions'
import Login from '../components/Login'

class LoginApp extends Component {
  render () {
    return React.createElement(Login, this.props)
  }

  componentDidMount () {
    const data = {}
    const search = window.location.search.split('?')[1]
    const query = parse(search)
    data.integration = query.integration
    window.analytics.page('Login', data)
  }
}

function mapStateToProps (state, { location: { query } }) {
  const { session } = state
  return {
    isLoading: session.isRequesting,
    didSubmitWrongPassword: session.wrongPassword,
    didSubmitWrongEmail: session.wrongEmail,
    hasError: session.error,
    didCreate: session.didCreate,
    email: session.email || query.email,
    password: session.password
  }
}

function mapDispatchToProps (dispatch) {
  return {
    onSubmit: data => dispatch(createSession(data))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginApp)



// WEBPACK FOOTER //
// ./containers/LoginApp.js